<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="header-wrapper d-flex">
      <h4 class="modal-title mb-0" id="modal-basic-title">
        {{ 'components.requestAnotherTimeSpecification.title' | translate }}
      </h4>
      @if (shouldRenderTooltip) {
        <app-tooltip [marginBottom]="false" text="requestAnotherTimeSpecification" />
      }
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isLoading"></app-spinner>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="lna-row grid">
          <div class="value-wrapper">
            <div class="label-wrapper">
              <label class="form-label lna" for="rescheduleDate">
                {{ 'components.requestAnotherTimeSpecification.rescheduleDate' | translate }}
              </label>
              <span class="required-field">*</span>
            </div>
            <app-date-picker
              [date]="rescheduleDate?.value"
              [invalid]="shouldRenderError('rescheduleDate')"
              [dateRangeMode]="dateRangeMode.All"
              (dateSelected)="onDateSelected($event, 'rescheduleDate')" />
            @if (this.shouldRenderError('rescheduleDate') && rescheduleDate?.errors) {
              @if (rescheduleDate?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              }
            }
          </div>

          <div class="value-wrapper">
            <div class="label-wrapper">
              <label class="form-label lna" for="rescheduleTimeFrom">
                {{ 'components.requestAnotherTimeSpecification.rescheduleTimeFrom' | translate }}
                <span class="required-field">*</span>
              </label>
            </div>
            <app-time-input
              [time]="rescheduleTimeFrom?.value || ''"
              [invalid]="shouldRenderError('rescheduleTimeFrom')"
              (timeChange)="onTimeChange($event, 'rescheduleTimeFrom')"
              (blured)="markAsTouched('rescheduleTimeFrom')" />
            @if (this.shouldRenderError('rescheduleTimeFrom') && rescheduleTimeFrom?.errors) {
              @if (rescheduleTimeFrom?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              }
            }
          </div>
          <div class="value-wrapper">
            <div class="label-wrapper">
              <label class="form-label lna" for="rescheduleTimeTo">
                {{ 'components.requestAnotherTimeSpecification.rescheduleTimeTo' | translate }}
              </label>
            </div>
            <app-time-input
              [time]="rescheduleTimeTo?.value || ''"
              [invalid]="shouldRenderError('rescheduleTimeTo')"
              (timeChange)="onTimeChange($event, 'rescheduleTimeTo')"
              (blured)="markAsTouched('rescheduleTimeTo')" />
            @if (this.shouldRenderError('rescheduleTimeTo') && rescheduleTimeTo?.errors) {
              @if (rescheduleTimeTo?.errors?.['timeRangeError']) {
                <small class="error-message">
                  {{ 'components.form.timeRangeError' | translate }}
                </small>
              }
            }
          </div>
        </div>
        <div class="lna-row">
          <div class="value-wrapper">
            <div class="mb-3">
              <div class="label-wrapper">
                <label class="form-label lna" for="name">
                  {{ 'components.requestAnotherTimeSpecification.reason' | translate }}
                </label>
                <span class="required-field">*</span>
              </div>
              <div class="textarea-wrapper">
                <textarea
                  class="form-control lna mb-0"
                  [ngClass]="{
                    invalid: this.shouldRenderError('rescheduleReason') && rescheduleReason?.errors
                  }"
                  [maxlength]="reasonMaxLength"
                  rows="5"
                  type="text"
                  formControlName="rescheduleReason"></textarea>
                <p class="length">{{ rescheduleReason?.value.length }}/{{ reasonMaxLength }}</p>
              </div>
              @if (this.shouldRenderError('rescheduleReason') && rescheduleReason?.errors) {
                @if (rescheduleReason?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                } @else if (rescheduleReason?.errors?.['maxlength']) {
                  <small class="error-message">
                    {{ 'components.form.maxLength' | translate: { maxLength: rescheduleReason?.errors?.['maxlength']['requiredLength'] } }}
                  </small>
                }
              }
            </div>
          </div>
        </div>
      </form>
    }
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isLoading" (click)="handleSave()" type="button">
      {{ 'components.requestAnotherTimeSpecification.submit' | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.requestAnotherTimeSpecification.cancel' | translate }}
    </button>
  </div>
</ng-template>
